var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _line, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 351,
    viewBox: "0 0 298 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.389 310.004C147.147 295.089 163.769 280.194 171.985 274.612C197.581 262.288 215.278 274.612 219.702 297.996C224.126 321.38 209.274 335.916 186.837 342.869C164.401 349.821 145.441 328.648 146.389 310.004Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.635 264.064C157.52 270.7 135.8 290.482 149.199 322.841C164.769 360.445 224.724 339.589 230.728 304.197C236.732 268.804 207.027 256.796 183.643 259.324",
    stroke: "#333333",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.111 294.719C177.639 299.459 183.011 311.084 183.011 319.683C183.011 324.421 221.248 277.654 244 278.602",
    stroke: "#333333",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 138.5H171.5L175 130.5L184 128L185.5 130.5L181.5 138.5Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93 239L57.5 288.5L50.5 277.5L45 258.5V233.5L75 206L98 173L111 142L124.5 132.5L154 129.5H160L163.5 127.5L169 125H176L174.5 132.5L163.5 149H169V155L166.5 162L169 169.5L166.5 179L163.5 192.5L158.5 196L146.5 199.5H138L135 196L130 202L128.5 212L124.5 220L106 233.5L93 239Z",
    fill: "#C8C7C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67 272C80.2 292.4 77 307.5 74 313.5L57.5 294C60.9168 286.667 68.0002 273.6 67 272Z",
    fill: "#241F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 268.5C15.5 262.9 8.66667 261.167 5 261L43 230C44.2 285.2 66.5 305.667 77.5 309C68.5 320.333 48.9 343.1 42.5 343.5C34.5 344 30 315.5 30 307.5C30 299.5 23 298.5 17 294.5C11 290.5 11 275.5 13.5 268.5Z",
    fill: "#241F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 264.5C13.5 252.833 36.2 229.7 43 230.5C42.8333 251.167 49.1 295.6 75.5 308C85 308 81.5 283.167 79 278.5",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38 348.5C50.1667 339.833 74.9 317.5 78.5 307.5",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57 290.5C63.5 278.833 80.3 252 95.5 238C109 232 119 229 129.5 211.5",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44 235C57.5 227.167 89.5 197.7 109.5 142.5C121 127.5 147.5 132 156 129",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114 210C123.333 208.167 142.6 197.3 145 168.5",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M219.5 56.5L160 90L157 92.5L164 130L170 123.5L176 125V130C193.167 123.333 227.6 108.8 228 104C228.4 99.2 222.5 70.3333 219.5 56.5Z",
    fill: "#D9D9D9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 150C134.5 150.333 146 145.9 168 125.5C177.5 120 176.333 128.5 175.5 130C174 136.833 165.6 153.7 144 166.5",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M166 150C168 150 171.8 150.8 171 154C170 158 161.025 169.87 157 173C152.5 176.5 147.5 176 144.5 176.5",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M167 163.5C170 165.333 171.4 172.2 167 177C161.5 183 155.5 188.5 141.5 188.5",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M166.5 179.5C166.166 183.5 164.8 191.9 162 193.5C158.5 195.5 142.5 201 139 198C136.2 195.6 139.5 190.667 142 189",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 126C159.833 114.5 155.3 91.3 158.5 90.5C161.7 89.7 202.167 66.8333 222 55.5",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M176 131C194 122 230.4 103.5 232 101.5C234 99 235 95 233.5 92C232.3 89.6 229 67 227.5 56",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M178.5 138.5C181.167 138.167 186.2 135.8 185 129",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M194 79.5L219.5 66.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M167 100.5C167.5 102.833 168.8 107.5 170 107.5C171.5 107.5 185 102 185 100.5C185 99 184 92 182.5 92C181.3 92 173.667 96.3333 170 98.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 178.343,
    y1: 117.652,
    x2: 217.343,
    y2: 98.6515,
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "8 2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M279.5 9.5C274.833 14.6667 265.4 25.9 265 29.5",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M295 50.5C291.167 50.6667 282 52.2 276 57",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 3C230 6.33333 233.2 15.4 234 25",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/payment-success.861ab3dd6944a5ca594c7cffff3ff319.svg";
export { ForwardRef as ReactComponent };